type EmailValidationResult = {
  valid: boolean
  errorMsg: string
}

export const validateEmail = (email?: string): EmailValidationResult => {
  if (!email) {
    return {
      valid: false,
      errorMsg: 'Email is required.',
    }
  }

  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

  if (!emailPattern.test(email)) {
    return {
      valid: false,
      errorMsg: 'Please enter a valid email address.',
    }
  }

  // Additional validation for edge cases
  if (email.includes('..') || email.startsWith('.') || email.endsWith('.')) {
    return {
      valid: false,
      errorMsg: 'Please enter a valid email address.',
    }
  }

  return {
    valid: true,
    errorMsg: '',
  }
}
